<form [formGroup]="formGroup()" class="row gap-md-0 gap-4">
  <div class="col-12 col-md-6">
    <div class="row gap-4">
      <!-- NAME -->
      <div class="col-sm-12">
        <app-form-input [id]="'name'"
                        [label]="('NAME'|translate)"
                        [controlName]="'name'"
                        [formGroup]="formGroup()"></app-form-input>
      </div>
      <!-- ERP URL -->
      <div class="col-sm-12">
        <app-form-input [id]="'erpUrl'"
                        [label]="('API_INTERFACES.ERP_URL'|translate)"
                        [controlName]="'erpUrl'"
                        [formGroup]="formGroup()"></app-form-input>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-6">
    <div class="row gap-4">
      <!-- API TOKEN -->
      <div class="col-sm-12">
        <app-form-input [id]="'apiToken'"
                        [label]="('API_INTERFACES.API_TOKEN'|translate)"
                        [controlName]="'apiToken'"
                        [formGroup]="formGroup()"></app-form-input>
      </div>
    </div>
  </div>
</form>
